<!-- Final CTA Section -->
<section
  class="py-24 bg-gradient-to-br from-indigo-50 via-white to-blue-50 border-t border-slate-200/60 relative overflow-hidden"
  aria-labelledby="cta-heading"
>
  <div class="container mx-auto px-6 relative z-10">
    <div
      class="daisy-card bg-white border border-slate-200/80 p-8 sm:p-16 rounded-3xl text-center max-w-5xl mx-auto shadow-lg space-y-8 relative overflow-hidden"
    >
      <!-- Headline -->
      <div class="space-y-4 max-w-3xl mx-auto">
        <div
          class="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider"
        >
          <i class="fa-solid fa-graduation-cap"></i>
          <span>Start Learning Today</span>
        </div>
        <h2
          id="cta-heading"
          class="text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight leading-tight"
        >
          Your Future Starts With Digital Excellence
        </h2>
        <p class="text-slate-600 text-lg sm:text-xl leading-relaxed">
          Join thousands of Sri Lankan students accessing expert tuition, live
          Zoom classes, and structured study resources on Learnbird.
        </p>
      </div>

      <!-- Action Buttons -->
      <div
        class="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4"
      >
        <a
          routerLink="/auth/register"
          class="daisy-btn daisy-btn-primary daisy-btn-lg bg-blue-600 hover:bg-blue-500 border-none text-white shadow-lg shadow-blue-500/20 flex items-center justify-center gap-3 rounded-2xl w-full sm:w-auto px-10"
        >
          <i class="fa-solid fa-rocket text-amber-300"></i>
          <span>Get Started Now</span>
        </a>
        <a
          routerLink="/live-classes"
          class="daisy-btn daisy-btn-outline daisy-btn-lg border-slate-300 text-slate-700 hover:bg-slate-100 flex items-center justify-center gap-3 rounded-2xl w-full sm:w-auto px-10"
        >
          <i class="fa-solid fa-book-open text-blue-600"></i>
          <span>Explore All Courses</span>
        </a>
      </div>

      <!-- Trust Badges -->
      <div
        class="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-8 border-t border-slate-200/80 text-xs sm:text-sm text-slate-600"
      >
        <div class="flex items-center justify-center gap-2">
          <i class="fa-solid fa-shield-halved text-emerald-600"></i>
          <span>Free Registration</span>
        </div>
        <div class="flex items-center justify-center gap-2">
          <i class="fa-solid fa-bolt text-amber-500"></i>
          <span>Instant Setup</span>
        </div>
        <div class="flex items-center justify-center gap-2">
          <i class="fa-solid fa-headset text-blue-600"></i>
          <span>24/7 Assistance</span>
        </div>
        <div class="flex items-center justify-center gap-2">
          <i class="fa-solid fa-star text-purple-600"></i>
          <span>Top Rated Tutors</span>
        </div>
      </div>
    </div>
  </div>
</section>
